module.exports = "<div class=\"spinner\">\n  <div class=\"loader\"></div>\n</div>"